import { createContext, useContext, useEffect, useState } from "react";
import { CURRENCIES } from "@/lib/site";

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const [code, setCode] = useState(() => sessionStorage.getItem("stupeco_currency") || "INR");

  useEffect(() => {
    sessionStorage.setItem("stupeco_currency", code);
  }, [code]);

  const currency = CURRENCIES.find((c) => c.code === code) || CURRENCIES[0];

  return (
    <CurrencyContext.Provider value={{ code, setCode, currency }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error("useCurrency must be used within CurrencyProvider");
  return ctx;
}
